import { SET_PRODUCT_COLLECTION_LAYOUT } from '../actions';
import { PRODUCT_COLLECTION_LAYOUT } from '../constants';
import { LayoutMode } from '../types';

export default (state, action) => {
  if (!state) {
    return {
      currentLayout: LayoutMode.GRID,
    };
  }

  switch (action.type) {
    case SET_PRODUCT_COLLECTION_LAYOUT:
      return {
        ...state,
        currentLayout: action.currentLayout,
      };

    case 'LOCAL_STORAGE_RECEIVE': {
      const productCollectionLayoutFromLocalStorage =
        action.localStorageState[PRODUCT_COLLECTION_LAYOUT];
      return {
        ...state,
        currentLayout: productCollectionLayoutFromLocalStorage,
      };
    }
    default:
      break;
  }

  return state;
};
